import { ApplicationController } from "stimulus-use";
import $ from "jquery";

export default class extends ApplicationController {

  connect() {
    // TODO: Eliminate dependency on this legacy tablesort jQuery plugin.
    // Build out a full-featured client-side HTML sorting system
    $(this.element).tablesort();
  }

}
